import { __assign } from "tslib";
/* No DS :( */
import React from 'react';
import IconWrap from '../IconWrap';
var ThemeSwitchGreen = function (props) {
    return (React.createElement(IconWrap, __assign({ disableDefaultColors: true }, props),
        React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 30 30" },
            React.createElement("g", { fill: "none", fillRule: "evenodd" },
                React.createElement("circle", { cx: "15", cy: "15", r: "11", fill: "#DAE6D6" }),
                React.createElement("circle", { cx: "15", cy: "15", r: "14", stroke: "transparent", strokeWidth: "2" }),
                React.createElement("path", { fill: "#475C4D", d: "M11 21H9.75a.75.75 0 01-.75-.75c0-.463.25-.89.654-1.118L11 18.375V18a4 4 0 014-4h2v-3a2 2 0 012-2h.5a1.5 1.5 0 01.5 2.914V15a3.001 3.001 0 01-2 2.829V21h-2v-2h-1v2h-2v-2l-.005.15A2 2 0 0111 21z" })))));
};
ThemeSwitchGreen.displayName = 'ThemeSwitchGreen';
export default ThemeSwitchGreen;
//# sourceMappingURL=ThemeSwitchGreen.js.map